import { DataTableFilterMetaData } from "primereact/datatable";

import Axios from "@/_helpers/axiosHelper";
import { LazyTableState, Lessor } from "@/common/interfaces.ts";

import {
  DwellingCostDilapidationsResponse,
  DwellingCostResponse,
  DwellingCostToolPlansResponse,
} from "../containers/DwellingEstimateContainer/types.ts";
import {
  IDwelling,
  IDwellingExpress,
  IResponseDwellings,
  IResponsePaginateServices,
  IResponseServices,
} from "../reducers";


export const addDwelling = (dwelling: IDwelling): Promise<{ id: string }> => {
  return Axios.post(`/agency/dwelling`, dwelling);
};
export const addDwellingExpress = (
  dwelling: IDwellingExpress
): Promise<IDwelling> => {

  return Axios.post(`/agency/dwelling-express`, dwelling);
};

export const getDwellingInfos = (id?: string): Promise<IDwelling> => {
  return Axios.get(`/agency/dwelling/${id}/infos`);
};

export const getDwellingLastServiceInventory = (
  id: string
): Promise<IDwelling> => {
  return Axios.get(`/agency/dwelling/${id}/last-service-inventory`);
};

export const getDwellings = (
  options: LazyTableState
): Promise<IResponsePaginateServices> => {
  const individualOrders: any = {};
  if (options?.multiSortMeta && options.multiSortMeta.length > 0) {
    for (const sort of options.multiSortMeta) {
      individualOrders[sort.field] = sort.order === 1 ? "asc" : "desc";
    }
  }
  const individualFilters: any = {};
  if (options?.filters) {
    for (const [key, value] of Object.entries(options.filters)) {
      individualFilters[key] = (value as DataTableFilterMetaData)?.value;
    }
  }
  return Axios.get("/agencies/dwellings", {
    params: {
      page: options?.page ? options.page + 1 : 1,
      perPage: options.rows,
      filter: options.filter,
      individualOrders,
      individualFilters,
    },
  });
};

export const getDwellingsAddress = (
  filter: string
): Promise<IResponseDwellings> => {
  return Axios.get("/agencies/dwellings", {
    params: { filter },
  });
};

export const deleteDwelling = (id: string) => {
  return Axios.delete(`/agency/dwelling/${id}`);
};

export const updateDwelling = (dwelling: IDwelling) => {
  return Axios.put(`/agency/dwelling/${dwelling.id}`, dwelling);
};

export const getDwellingServices = (
  page: number,
  dwellingId: string
): Promise<IResponseServices> => {
  return Axios.get(`/agency/dwelling/${dwellingId}/services`, {
    page,
    dwellingId,
  });
};

export const getDwellingServicesInventory = (
  page: number,
  dwellingId: string,
  types?: string[]
): Promise<IResponseServices> => {
  return Axios.get(`/agency/dwelling/${dwellingId}/services`, {
    page,
    dwellingId,
    types,
  });
};

export const uploadDwellingFiles = (id: string, files: any[]) => {
  const formData = new FormData();
  files.forEach((file, index) => {
    formData.append(`files[${index}][content]`, file.content);
    if (file.url) {
      formData.append(`files[${index}][exist]`, "true");
    }
    formData.append(`files[${index}][type][label]`, file.type.label);
    formData.append(`files[${index}][type][value]`, file.type.value);
  });

  return Axios.post(`/agency/dwelling/${id}/files`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const removeDwellingFile = (dwellingId: string, fileId: string) => {
  return Axios.delete(`/agency/dwelling/${dwellingId}/file/${fileId}`);
};

export const deleteDwellingFile = (dwellingId: string, fileId: string) => {
  return Axios.delete(`/agency/dwelling/${dwellingId}/files/${fileId}`);
};

export const getDwellingCostingTool = (dwellingId: string) => {
  return Axios.get(
    `/agency/dwelling/${dwellingId}/costing-tool`
  ) as Promise<DwellingCostResponse>;
};

export const getDwellingCostingToolPlans = (dwellingId: string) => {
  return Axios.get(
    `/agency/dwelling/${dwellingId}/costing-tool-plans`
  ) as Promise<DwellingCostToolPlansResponse>;
};

export const getDwellingCleaningPlans = (dwellingId: string) => {
  return Axios.get(
    `/agency/dwelling/${dwellingId}/costing-tool-cleanings`
  ) as Promise<DwellingCostToolPlansResponse>;
};

export const getDwellingCostingToolDilapidations = (dwellingId: string) => {
  return Axios.get(
    `/agency/dwelling/${dwellingId}/costing-tool-dilapidations`
  ) as Promise<DwellingCostDilapidationsResponse>;
};

export const updateDwellingCostingTool = (
  dwellingId: string,
  data: DwellingCostResponse
): Promise<{ path: string }> => {
  return Axios.put(`/agency/dwelling/${dwellingId}/costing-tool`, {
    costing: data,
  });
};

export const getLessors = () => {
  return Axios.get(`/lessors`) as Promise<Lessor[]>;
}
